import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { mockProducts } from '../data/mockData';

const ProductGrid = ({ limit }) => {
  const navigate = useNavigate();
  const products = limit ? mockProducts.slice(0, limit) : mockProducts;
  const [visibleProducts, setVisibleProducts] = useState([]);
  const productRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = productRefs.current.indexOf(entry.target);
            if (index !== -1 && !visibleProducts.includes(index)) {
              setVisibleProducts((prev) => [...prev, index]);
            }
          }
        });
      },
      { threshold: 0.2 }
    );

    productRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
      {products.map((product, index) => (
        <div
          key={product.id}
          ref={(el) => (productRefs.current[index] = el)}
          className={`group cursor-pointer transform transition-all duration-1000 ${
            visibleProducts.includes(index)
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-12'
          }`}
          onClick={() => navigate(`/product/${product.id}`)}
          style={{ transitionDelay: `${index * 150}ms` }}
        >
          {/* Product Image */}
          <div className="relative aspect-[3/4] overflow-hidden bg-neutral-50 mb-6">
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            {product.isNew && (
              <div className="absolute top-4 right-4 bg-black text-white text-xs tracking-[0.2em] px-4 py-2 animate-fade-in">
                NEW
              </div>
            )}
            {/* Hover Overlay */}
            <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          </div>

          {/* Product Info */}
          <div className="space-y-3">
            <h3 className="text-2xl font-light tracking-wide group-hover:translate-x-2 transition-transform duration-500">
              {product.name}
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed line-clamp-2">
              {product.description}
            </p>
            <div className="pt-2">
              <span className="text-sm tracking-[0.2em] uppercase text-gray-500">
                {product.category}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductGrid;